// extracted by mini-css-extract-plugin
export default {"list":"index_list_MSWCe","time":"index_time_3dNZz","green":"index_green_Xy011","more":"index_more_RcLmj","empty":"index_empty_p26BP"};